<template>
    <div class="w-full py-6 border-b border-gray-300">
        <div class="w-full pb-6 text-xl">
            <div v-html="trainingDocumentHead"></div>
        </div>
        <div>
            <div v-html="trainingDocumentBody"></div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['trainingDocument'])


const trainingDocumentHead = computed(() => {
    return props.trainingDocument ? props.trainingDocument.head : '--'
})

const trainingDocumentBody = computed(() => {
    return props.trainingDocument ? props.trainingDocument.body : '--'
})


</script>